import React from "react";
import {
  testimonials_container,
  testimoniaWrap,
  image_container,
  testimonials,
  testimonial,
  dots_container,
  dot,
  testimonial_logo,
  active,
} from "./Testimonials.module.scss";
import { useKeenSlider } from "keen-slider/react";
import { GatsbyImage } from "gatsby-plugin-image";
import "keen-slider/keen-slider.min.css";
import parse from "html-react-parser";
const Testimonials = ({ testimonialsData }) => {
  const [currentSlide, setCurrentSlide] = React.useState(0);
  const [sliderRef, slider] = useKeenSlider({
    initial: 0,
    slidesPerView: 1,
    slideChanged(s) {
      setCurrentSlide(s.details().relativeSlide);
    },
  });

  return (
    <div
      className={`${testimonials_container} bkg-${testimonialsData.ColorTheme}`}
    >
      <div className={image_container}>
        <img src={testimonialsData.Pattern.localFile.publicURL} alt="shapes" />
      </div>
      <div className={`${testimonials} bkg-${testimonialsData.ColorTheme}`}>
        <div className={testimoniaWrap}>
          {testimonialsData.testimonials.length > 1 ? (
            <React.Fragment>
              <div ref={sliderRef} className="keen-slider">
                {testimonialsData.testimonials.map(
                  ({ Name, Role, Copy, Logo }, index) => {
                    return (
                      <div
                        key={index}
                        className={`keen-slider__slide ${testimonial}`}
                      >
                        <h4>{parse(Copy)}</h4>
                        <p>{Name}</p>
                        <p className="ui">{Role}</p>
                        <GatsbyImage
                          image={Logo.localFile.childImageSharp.gatsbyImageData}
                          alt={Logo.alternativeText}
                          className={testimonial_logo}
                        />
                      </div>
                    );
                  }
                )}
              </div>
              {slider && (
                <div
                  className={`${dots_container} bkg-${testimonialsData.ColorTheme}`}
                >
                  {[...Array(slider.details().size).keys()].map((idx) => {
                    return (
                      <button
                        type="button"
                        aria-label="dot"
                        key={idx}
                        onClick={() => {
                          slider.moveToSlideRelative(idx);
                        }}
                        className={`${dot} ${
                          currentSlide === idx ? active : ""
                        }`}
                      />
                    );
                  })}
                </div>
              )}
            </React.Fragment>
          ) : (
            <React.Fragment>
              {testimonialsData.testimonials.map(
                ({ Name, Role, Copy, Logo }, index) => {
                  return (
                    <div
                      key={index}
                      className={`keen-slider__slide ${testimonial}`}
                    >
                      <h4>{parse(Copy)}</h4>
                      <p>{Name}</p>
                      <p className="ui">{Role}</p>
                      <GatsbyImage
                        image={Logo.localFile.childImageSharp.gatsbyImageData}
                        alt={Logo.alternativeText}
                        className={testimonial_logo}
                      />
                    </div>
                  );
                }
              )}
            </React.Fragment>
          )}
        </div>
      </div>
    </div>
  );
};

export default Testimonials;
